// extracted by css-extract-rspack-plugin
export default {"colorBorderPrimary":"#e1e1e1","separator":"horizontal-separator__separator___o9eZh"};